export default "__VITE_ASSET__CkkECcVy__"